// aiagent markdown 渲染：markdown-it + DOMPurify 消毒（XSS 防护），chat 与生成页共用
import MarkdownIt from 'markdown-it'
import DOMPurify from 'dompurify'

const md = new MarkdownIt({ html: false, linkify: true, breaks: true })

// 链接统一新窗口打开，避免点击后整页跳转丢失对话
const defaultLinkOpen = md.renderer.rules.link_open ||
  ((tokens, idx, options, env, self) => self.renderToken(tokens, idx, options))
md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
  const t = tokens[idx]
  if (t.attrIndex('target') < 0) t.attrPush(['target', '_blank'])
  if (t.attrIndex('rel') < 0) t.attrPush(['rel', 'noopener noreferrer'])
  return defaultLinkOpen(tokens, idx, options, env, self)
}

/**
 * 渲染 markdown 为消毒后的 HTML 片段（供 v-html 使用）
 * ADD_ATTR 补充 target：DOMPurify 默认白名单不含 target（含 rel），不加会被剥离导致链接同页跳转；
 * target 值固定 _blank 且已配 rel=noopener noreferrer，无 reverse tabnabbing 风险
 * @param {string} text markdown 原文
 * @returns {string} HTML
 */
export function renderMarkdown(text) {
  if (!text) return ''
  return DOMPurify.sanitize(md.render(text), { ADD_ATTR: ['target'] })
}
